<template> 
  <EditUser /> 
</template> 

<script> 
  import EditUser from '../components/EditUser' 
  export default { 
    components: { 
      EditUser 
    } 
  } 
</script> 